import { CALENDLY_WIDGET } from 'src/components/CalendlyWidget/calendly.constants';
import { useEffect, useRef, useState } from 'react';

const createDiv = (className = 'hidden min-w-full h-[1050px]') => {
  const element = document.createElement('div');

  element.dataset.url = CALENDLY_WIDGET.DATA_URL;
  element.setAttribute('class', `calendly-inline-widget ${className}`);

  return element;
};

const createScript = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = CALENDLY_WIDGET.SCRIPT_SRC;

  return script;
};

export const CalendlyWidget = ({ name = '', email = '' }) => {
  const [calendlyLoaded, setCalendlyLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current) {
      !ref.current.querySelector('div') && ref.current.appendChild(createDiv());
      !ref.current.querySelector('script') && ref.current.appendChild(createScript());
    }

    const interval = setInterval(() => {
      if (globalThis.Calendly) {
        setCalendlyLoaded(true);
        clearInterval(interval);
      }
    }, 300);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (calendlyLoaded && globalThis.Calendly) {
      const el = globalThis.document.querySelector('.calendly-inline-widget');

      if (el) {
        el.innerHTML = '';

        globalThis.Calendly.initInlineWidget({
          url: CALENDLY_WIDGET.DATA_URL,
          parentElement: el,
          prefill: {
            name: name,
            email: email,
          },
        });

        el.classList.remove('hidden');
      }
    }
  }, [calendlyLoaded]);

  return <div ref={ref}></div>;
};
